import { attackSkill } from "./attack";
import { defendSkill } from "./defend";
import { slashSkill } from "./slash";
import { bloodPactSkill } from "./bloodPact";
import type { SkillDefinition } from "./types";

const SKILL_LIST = [attackSkill, slashSkill, defendSkill, bloodPactSkill] as const;

export type SkillId = (typeof SKILL_LIST)[number]["id"];

export type SkillMap = Record<SkillId, SkillDefinition<SkillId>>;

export const SKILLS = SKILL_LIST.reduce((acc, skill) => {
  acc[skill.id] = skill;
  return acc;
}, {} as SkillMap);

export type { SkillDefinition, SkillUseContext } from "./types";
